'use strict';

const { matchesFuzzy, highlightWords } = require('./m_typeahead_helper_es6');
const { normalizeQuery } = require('./m_normalizeQuery.coffee');

const clearingPartial = require('./templates/partial_clearing.html.mustache');
const newBadgePartial = require('./templates/partial_new_badge.html.mustache');
const currentLocationPartial = require('./templates/partial_current_location.html.mustache');
const recentLocationPartial = require('./templates/partial_recent_location.html.mustache');
const autocompletePartial = require('./templates/partial_autocomplete.html.mustache');
const recentSearchPartial = require('./templates/partial_recent_search.html.mustache');
// const myPlacesPartial = require('./templates/partial_my_places.html.mustache');
const searchCategoriesPartial = require('./templates/partial_search_categories.html.mustache');
const recentlyViewedDealsPartial = require('./templates/partial_recently_viewed_deals.html.mustache');

const locationTemplate = require('./templates/template_location.html.mustache');
const searchTemplate = require('./templates/template_search.html.mustache');
// const { getSigninUrl } = require('../../general/m_userSessionAddReferrer.coffee');
const { toCamelCase } = require('../../../../../src/helpers/camelCase.coffee');

// Build the html of the autocomplete
class TypeAHeadBuilder {
  constructor() {
    const translations = Groupon.LS.translations;
    this.t = {
      currentlocation: translations.search && translations.search.currentlocation,
      remove: translations.ax.remove,
      clearall: translations.search.clearall,
      recentSearchs: translations.search.recentdeals,
      recentLocations: translations.search.recentlocations,
      recentlyViewedDeals: translations.search.recently_viewed_deals,
      categories: translations.categories || {},
      newBadge: translations.general.newbadge,
      // signIn: 'Sign in', // TODO: translation
      // myPlaces: translations.search.myPlaces || 'My Places', // TODO: translation
      // addMyPlace: translations.search.addMyPlace || 'Add Address', // TODO: translation
      seeMore: 'See more',
      // myPlaceTypes: { // TODO: translation
      //   home: translations.search.myPlaceTypeHome || 'Home',
      //   work: translations.search.myPlaceTypeWork || 'Work',
      //   play: translations.search.myPlaceTypeFavorite || 'Favorite',
      // },
    };
  }

  // Injects html tags to separate the neighborhood and the city
  deEmphasis(label = '', len = 2) {
    const res = label.split(/,(.+)?/);
    const parts = label.split(',');
    if (parts.length < len) {
      return label;
    }
    let tag = '<em>';
    if (label.indexOf('<strong>') > -1) {
      // strong tags present either in <neightborhood> or <city , state>"
      if (!(res[0].indexOf('</strong>') > -1 || res[1].indexOf('<strong>') > -1)) {
        // strong tags present in both parts of the label
        tag = '</strong><em><strong>';
      }
    }
    res.splice(1, 0, tag);
    res.splice(3, 0, '</em>');
    return res.join('');
  }

  // Format tag
  prepareBloodhoundTag(tag = '') {
    return tag.toLowerCase().replace(/[^\w\d]+/g, '_');
  }

  // get all the default data
  getDefaultData(collections, query, config = {}) {
    const firstWidget = collections[0] && (collections[0].widget || '');

    this.experiments = {
      showAlt: config.showAlt,
    };

    let bh;
    if (firstWidget === 'autocomplete') {
      bh = {
        type: 'bhc',
        val: `UserTyped:${query}`,
      };
    }

    return {
      t: this.t,
      isDesktop: config.isDesktop,
      query,
      bh,
    };
  }

  // build the autocomplete view for deals search
  buildSearchView(collections, query, config = {}) {
    const data = Object.assign(this.getDefaultData(collections, query, config), {
      items: this.buildSearchItems(collections, query),
    });

    const partials = {
      autocompletePartial,
      recentSearchPartial,
      searchCategoriesPartial,
      recentlyViewedDealsPartial,
      clearingPartial,
      newBadgePartial,
    };

    return searchTemplate.render(data, partials);
  }

  buildSearchItems(collections, query) {
    const items = collections.reduce((results, { collection, widget }) => {
      switch (widget) {
        case 'autocomplete':
          return results.concat(this.buildAutocomplete(collection, query));
        case 'recentSearches':
          return results.concat(this.buildRecentSearches(collection, query));
        case 'searchCategories':
          return results.concat(this.buildSearchCategories(collection, query));
        case 'recentlyViewedDeals':
          return results.concat(this.buildRecentlyViewedDeals());
        default:
      }
      return results;
    }, []);
    return items;
  }

  createBloodhoundTag(type = '') {
    return type.split('|').slice(-1).join('').toLowerCase()
  }

  buildSearchCategory(categoryType, categoryItems, level = 1) {
    const name = this.t.categories[categoryType]; // get name from translation
    const baseBHC = this.createBloodhoundTag(categoryType);
    let heading = null;

    if (name) {
      heading = {
        isSearchCategoriesHeader: true,
        name,
      };
    }

    const baseUrl = categoryItems[0] ? categoryItems[0].baseUrl : null;
    if (baseUrl) {
      categoryItems.shift(); // remove the baseUrl item
    }

    const items = categoryItems.map((item) => {
      /*
      # item can be either of type "Array" or "Object"
      # API facets are normally mapped as arrays
      # while config or constructed entries (all deals) ar
      # mapped as object.
      */
      const dataItem = {
        isSearchCategoryItem: true,
        item,
      };

      if (Array.isArray(item)) {
        const [id, friendlyName, count, subcategories] = item;
        Object.assign(dataItem, { id, friendlyName, count, subcategories, url: baseUrl + id });
      } else {
        const { i: id, n: friendlyName, c: count, s: subcategories, u: url, newBadge } = item;
        Object.assign(dataItem, { id, friendlyName, count, subcategories, newBadge, url });
      }
      dataItem.bhc = `${baseBHC}:${(dataItem.id || 'all-deal').toLowerCase()}`;

      return dataItem;
    });

    return {
      isSearchCategory: true,
      type: categoryType,
      heading,
      menuID: categoryType.split('|').pop(),
      items,
      level,
    };
  }

  // search categories for mobile search
  buildSearchCategories(collection) {
    if (!collection || !collection[0]) {
      return [];
    }

    const categoriesMap = collection[0];

    return Object.keys(categoriesMap).reduce((result, categoryType) => {
      const categoryItems = categoriesMap[categoryType] || [];
      if (categoryItems.length) { // check category items
        result.push(this.buildSearchCategory(categoryType, categoryItems.slice(0)));
      }
      return result;
    }, []);
  }

  buildRecentSearches(collection) {
    if (!collection || !collection.length) {
      return [];
    }

    const recentSearches = collection.map((item, n) => ({
      isRecentSearchItem: true,
      item,
      n,
      bhc: this.prepareBloodhoundTag(item),
    }));

    return [
      { isRecentSearchHeader: true },
      {
        isRecentSearches: true,
        displayAltRecentSearch: this.experiments ? this.experiments.showAlt : false,
        recentSearches,
        truncate: (recentSearches.length > 3 ? true : false),
      },
    ];
  }


  // build the autocomplete view for location search
  buildLocationView(collections, query, config = {}) {
    const data = Object.assign(
      this.getDefaultData(collections, query, config),
      this.buildLocationItems(collections, query, config)
    );

    const partials = {
      currentLocationPartial,
      recentLocationPartial,
      clearingPartial,
      autocompletePartial,
      // myPlacesPartial,
    };

    return locationTemplate.render(data, partials);
  }

  buildLocationItems(collections, query, config) {
    let isGeoLocation = false;
    const items = collections.reduce((results, { collection, widget }) => {
      switch (widget) {
        case 'geolocation':
          isGeoLocation = true;
          break;
        case 'recentLocations':
          return results.concat(this.buildRecentLocations(collection));
        case 'autocomplete':
          return results.concat(this.buildAutocomplete(collection, query));
        // case 'myPlaces':
        //   return results.concat(this.buildMyPlaces(collection, query, config));
        default:
      }
      return results;
    }, []);
    return {
      items,
      isGeoLocation,
    };
  }

  // recent location list
  buildRecentLocations(collection) {
    if (!collection || !collection.length) {
      return [];
    }

    const items = collection.map((item, n) => {
      const { address } = item;
      // set value as full address
      const value = address;
      // display address without zipcode and country
      const label = this.deEmphasis(address, 3);
      return Object.assign({}, item, {
        isRecentLocationItem: true,
        n,
        value,
        label,
        bhc: this.prepareBloodhoundTag(address),
      });
    });
    items.unshift({ isRecentLocationHeader: true });

    return items;
  }

  buildAutocomplete(collection, query) {
    if (!collection || !collection.length) {
      return [];
    }

    return collection.map((item, n) => {
      let { value, label, address } = item;

      if (item.lat && item.neighborhood) {
        label = this.deEmphasis(label);
      }

      if (item.locationId && address) {
        value = address;
        address = highlightWords(address, matchesFuzzy(query, address, true));
        label = this.deEmphasis(address);
      }

      return Object.assign({}, item, {
        isAutocomplete: true,
        n,
        value,
        address,
        label,
        highlight: normalizeQuery(value) === query,
      });
    });
  }

  buildRecentlyViewedDeals() {
    return [{
      isRecentlyViewedDeals: true,
    }];
  }

  // buildMyPlaces(collection, query, config) {
  //   let isAddMyPlace = true;
  //   let isMorePlace = false;
  //   let displayedItems = collection;
  //   if (config.places.needToBeCollapsed()) {
  //     displayedItems = collection.slice(0, 3);
  //     isAddMyPlace = false;
  //     isMorePlace = true;
  //   }
  //
  //   const items = displayedItems.map((item, n) => {
  //     const { address, type } = item;
  //     return Object.assign(item, {
  //       isMyPlacesItem: true,
  //       n,
  //       bhc: this.prepareBloodhoundTag(address),
  //       name: this.t.myPlaceTypes[type] || this.t.myPlaceTypes.home,
  //     });
  //   });
  //
  //   const signInUrl = !config.isLoggedIn ? getSigninUrl() : null;
  //   items.unshift({ isMyPlacesHeader: true, signInUrl });
  //   if (isAddMyPlace) {
  //     items.push({ isAddMyPlace });
  //   }
  //   if (isMorePlace) {
  //     items.push({ isMorePlace });
  //   }
  //
  //   return items;
  // }
}

module.exports = new TypeAHeadBuilder();
